// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"cee15c82","212":"d1ced5b0","244":"abfdb3b7","248":"df7b74a4","330":"e82d3df1","418":"33f95e99"}[chunkId] + ".chunk.css";
};